import React from 'react';
import './Hero.css';

const Hero = ({ data }) => {
  return (
    <section id="home" className="hero">
      <div className="container">
        <div className="hero-wrapper">
          <div className="hero-content">
            <p className="hero-greeting">Hi, my name is</p>
            <h1 className="hero-name">{data.name}</h1>
            <h2 className="hero-title">
              {data.title.split('&').map((part, i) => (
                <span key={i}>
                  {part.trim()}
                  {i < data.title.split('&').length - 1 && (
                    <span className="accent-text"> & </span>
                  )}
                </span>
              ))}
            </h2>
            <p className="hero-subtitle">{data.subtitle}</p>
            <p className="hero-description">
              {data.recentHighlights}
            </p>
            <div className="hero-cta">
              <a href="#projects" className="btn btn-primary">View Projects</a>
              <a href="#contact" className="btn btn-outline">Get In Touch</a>
              <a href="https://contra.com/yanick_landry_6tw8c2qg" target="_blank" rel="noopener noreferrer" className="btn btn-outline">Hire me on Contra</a>
            </div>
          </div>
          <div className="hero-3d-container">
            <div className="hero-3d-element">
              <div className="hero-3d-face hero-3d-front">
                <div className="hero-3d-window">
                  <div className="hero-3d-window-bar">
                    <div className="hero-3d-window-controls">
                      <span className="hero-3d-control hero-3d-control-close"></span>
                      <span className="hero-3d-control hero-3d-control-minimize"></span>
                      <span className="hero-3d-control hero-3d-control-maximize"></span>
                    </div>
                  </div>
                  <div className="hero-3d-window-content">
                    <span className="hero-3d-text">http://</span>
                  </div>
                </div>
              </div>
              <div className="hero-3d-face hero-3d-back"></div>
              <div className="hero-3d-face hero-3d-right"></div>
              <div className="hero-3d-face hero-3d-left"></div>
              <div className="hero-3d-face hero-3d-top"></div>
              <div className="hero-3d-face hero-3d-bottom"></div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Hero;
